
<router-outlet > </router-outlet>
<div class="d-flex justify-content-center align-items-center flex-column footer-wrapper  hidePrint">
  <div>Une réalisation du Keepic'Lab à Poitiers (86).</div>
  <div>Rendez-nous visite sur &nbsp; <a class="ui-login-link" href="https://www.keepic.net" target="_new">www.keepic.net</a> !</div>
</div>
